import SystemApiBase from "../base/SystemApiBase";

import { type OkResponse } from "@/schemas/api/ok";
import {
  type AccountCreationRequest,
  type ChangePasswordRequest,
  type ConfirmPasswordResetRequest,
  type LoginRequest,
  type RefreshTokenRequest,
  type VerifyAccountRequest,
} from "@/schemas/auth/cognito";
import {
  type AppUserSession,
  type DeleteUserRequest,
} from "@/schemas/auth/session";

class AuthService extends SystemApiBase {
  public constructor() {
    super("/auth");
  }

  public async login(request: LoginRequest): Promise<AppUserSession> {
    const response = await this.post<AppUserSession>("/login", { ...request });
    return response;
  }

  public async refreshToken(
    request: RefreshTokenRequest,
  ): Promise<AppUserSession> {
    const response = await this.post<AppUserSession>("/refresh_token", {
      ...request,
    });
    return response;
  }

  public async register(request: AccountCreationRequest): Promise<OkResponse> {
    const response = await this.post<OkResponse>("/register", { ...request });
    return response;
  }

  public async verifyAccount(
    request: VerifyAccountRequest,
  ): Promise<OkResponse> {
    const response = await this.post<OkResponse>("/verify_account", {
      ...request,
    });
    return response;
  }

  public async resendVerificationCode(username: string): Promise<OkResponse> {
    const response = await this.post<OkResponse>("/resend_verification_code", {
      username,
    });
    return response;
  }

  public async passwordResetRequest(email: string): Promise<OkResponse> {
    const response = await this.post<OkResponse>("/password_reset", { email });
    return response;
  }

  public async confirmPasswordReset(
    request: ConfirmPasswordResetRequest,
  ): Promise<OkResponse> {
    const response = await this.post<OkResponse>("/confirm_password_reset", {
      ...request,
    });
    return response;
  }

  public async changePassword(
    request: ChangePasswordRequest,
  ): Promise<OkResponse> {
    const response = await this.post<OkResponse>("/change_password", {
      ...request,
    });
    return response;
  }

  public async logout(username: string): Promise<OkResponse> {
    const response = await this.post<OkResponse>("/signout", { username });
    return response;
  }

  public async deleteUser(request: DeleteUserRequest): Promise<OkResponse> {
    const response = await this.post<OkResponse>("/delete_user", {
      ...request,
    });
    return response;
  }
}

export default AuthService;
